/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minimum_ChargeInputs */



/**
* | output |
* | --- |
* | "Minimum charge: $3.00 USD" |
*
* @param {Minimum_ChargeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const minimum_charge = /** @type {((inputs?: Minimum_ChargeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minimum_ChargeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Frais minimum : 3,00 $ US")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mindestgebühr: 3,00 USD")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importo minimo: 3,00 USD")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Минимальная сумма заказа: 3,00 доллара США.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargo mínimo: $3.00 USD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最低收费：3.00 美元")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最低料金：3.00米ドル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("न्यूनतम शुल्क: $3.00 USD")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cobrança mínima: US$ 3,00")
	return /** @type {LocalizedString} */ ("Minimum charge: $3.00 USD")
});